//  ========================================================
//  tlab-recommend.js ---- recommend view class
//  Copyright 2008 TEAM-LAB
//  ========================================================

if ( typeof(TLAB) == 'undefined' ) TLAB = function() {};

TLAB.Recommend = function (arg1, arg2, arg3, arg4) {
	this.elem = arg1;
	this.url = "https://asp-rcmd01-api.team-rec.jp/cl021/recommend.js?ctype=" + arg3 + "&item=" + arg2 + "&design=" + arg4;
	return this;
}
TLAB.Recommend.prototype.sendRequest = function () {
	var jsElement=document.createElement("script");
	jsElement.type="text/javascript";
	jsElement.src=this.url;
	jsElement.characterSet="UTF-8";
	document.getElementById(this.elem).appendChild(jsElement);
}

TLAB.Personal = function (arg1, arg2, arg3, arg4) {
	this.elem = arg1;
	this.id = '';
	if(arg2){
		this.id = '&item=' + arg2;
	}
	this.url = "https://asp-rcmd01-api.team-rec.jp/cl021/personal.js?ctype=" + arg3 + this.id + "&design=" + arg4;
	return this;
}
TLAB.Personal.prototype.sendRequest = function () {
	var jsElement=document.createElement("script");
	jsElement.type="text/javascript";
	jsElement.src=this.url;
	jsElement.characterSet="UTF-8";
	document.getElementById(this.elem).appendChild(jsElement);
}

TLAB.PersonalTop = function (arg1, arg2, arg3, arg4) {
	this.elem = arg1;
	this.id = '';
	if(arg2){
		this.id = '&item=' + arg2;
	}
	this.url = "https://asp-rcmd01-api.team-rec.jp/cl021/personal.js?ctype=" + arg3 + this.id + "&design=" + arg4;
	return this;
}
TLAB.PersonalTop.prototype.sendRequest = function () {
	var jsElement=document.createElement("script");
	jsElement.type="text/javascript";
	jsElement.src=this.url;
	jsElement.characterSet="UTF-8";
	document.getElementById(this.elem).appendChild(jsElement);
}

TLAB.RankingCategory = function (arg1, arg2, arg3, arg4) {
	this.elem = arg1;
	this.url = "https://asp-rcmd01-api.team-rec.jp/cl021/ranking.js?ctype=" + arg2 + "&cat=" + arg3 + "&design=" + arg4;
	return this;
}
TLAB.RankingCategory.prototype.sendRequest = function () {
	var jsElement=document.createElement("script");
	jsElement.type="text/javascript";
	jsElement.src=this.url;
	jsElement.characterSet="UTF-8";
	document.getElementById(this.elem).appendChild(jsElement);
}
